// extracted by mini-css-extract-plugin
export default {"body":"support_body__pGAYq","container":"support_container__npJcH"};